module.exports = __webpack_public_path__ + "img/pr-10.ec4eb093.png";